import { Box, convertHexToRGBA, Text, useWindowDimensions } from '@jfs/ui-new'
import { useEffect, useRef } from 'react'
import { FlatList, TouchableOpacity } from 'react-native'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const TabBar = ({ state, descriptors, navigation }: { state: any; descriptors: any; navigation: any }) => {
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)

  const listRef = useRef<FlatList<any>>(null)

  const scrollTo = (index: number) => {
    if (listRef?.current !== null) {
      listRef?.current?.scrollToIndex({ index: index, animated: true })
    }
  }

  useEffect(() => {
    scrollTo(state.index)
  }, [state.index])

  const renderItem = ({ item, index }: any) => {
    const { options } = descriptors[item.key]
    const label =
      options.tabBarLabel !== undefined ? options.tabBarLabel : options.title !== undefined ? options.title : item.name

    const isFocused = state.index === index

    const onPress = () => {
      const event = navigation.emit({
        type: 'tabPress',
        target: item.key,
        canPreventDefault: true,
      })

      if (!isFocused && !event.defaultPrevented) {
        navigation.navigate(item.name)
      }
    }

    return (
      <Box mr={8}>
        <TouchableOpacity
          accessibilityRole="button"
          accessibilityState={isFocused ? { selected: true } : {}}
          accessibilityLabel={options.tabBarAccessibilityLabel}
          onPress={onPress}
          style={{
            height: isMobile ? 30 : 32,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 16,
            paddingHorizontal: 16,
            backgroundColor: isFocused ? '#0070B6' : convertHexToRGBA('#212121', 8),
          }}>
          <Text color={isFocused ? 'WHITE' : 'BLACK_75'} fontFamily={'jiotype-medium'} fontSize={12}>
            {label}
          </Text>
        </TouchableOpacity>
      </Box>
    )
  }
  const resPadding = usePadding()
  return (
    <Box
      flexDirection={'row'}
      pl={resPadding}
      borderBottomWidth={isMobile ? 1 : 0}
      borderBottomColor={'DISABLED_GREY'}
      pb={8}>
      <FlatList
        ref={listRef}
        data={state?.routes}
        renderItem={renderItem}
        horizontal
        onScrollToIndexFailed={() => {}}
        showsHorizontalScrollIndicator={false}
      />
    </Box>
  )
}
